import React, { useState } from "react";
import { CommandBarButton, Aside } from "sprint-common-web";

import { CreateLanguageForm } from "./CreateLanguageForm";

export const AddLanguageButton: React.VFC = () => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" />
            <Aside isOpen={isAsideOpen} type="form" headerText="Add Language" onDismiss={closeAside}>
                <CreateLanguageForm onCancel={closeAside} onSubmit={closeAside} />
            </Aside>
        </>
    );
};
